import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=41720e52&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=41720e52&lang=less"

import exportComponent from "D:\\project\\zillion\\developCompany\\pzh_develop_website发展集团官网\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41720e52"]])

export default __exports__